<template>
  <div class="company-videos-container">
    <!-- Grid Layout -->
    <div v-if="layout_type === 'grid'" class="video-grid row">
      <div v-for="videoId in videos" 
           :key="videoId"
           class="col-xs-12 col-sm-6 col-md-4 video-wrapper">
        <div class="video-responsive">
          <iframe 
            :src="`https://www.youtube.com/embed/${videoId}`"
            frameborder="0"
            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen>
          </iframe>
        </div>
      </div>
    </div>

    <!-- Carousel Layout -->
    <div v-else class="video-carousel">
      <div class="carousel-container">
        <div class="carousel-slide">
          <div class="video-responsive">
            <iframe 
              :src="`https://www.youtube.com/embed/${currentVideo}`"
              frameborder="0"
              allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen>
            </iframe>
          </div>
        </div>
        
        <!-- Carousel Navigation -->
        <button 
          class="carousel-nav prev" 
          @click="previousVideo"
          :disabled="currentIndex === 0">
          &#8249;
        </button>
        <button 
          class="carousel-nav next" 
          @click="nextVideo"
          :disabled="currentIndex === videos.length - 1">
          &#8250;
        </button>
        
        <!-- Video Indicators -->
        <div class="carousel-indicators">
          <button
            v-for="(video, index) in videos"
            :key="video"
            class="indicator"
            :class="{ active: index === currentIndex }"
            @click="setVideo(index)">
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CompanyVideos',
  
  props: {
    videos: {
      type: Array,
      required: true,
      validator: function(value) {
        return value.every(item => typeof item === 'string' && item.length > 0);
      }
    },
    layout_type: {
      type: String,
      required: true,
      validator: function(value) {
        return ['grid', 'carousel'].includes(value);
      }
    }
  },

  data() {
    return {
      currentIndex: 0
    };
  },

  computed: {
    currentVideo() {
      return this.videos[this.currentIndex];
    }
  },

  methods: {
    nextVideo() {
      if (this.currentIndex < this.videos.length - 1) {
        this.currentIndex++;
      }
    },
    previousVideo() {
      if (this.currentIndex > 0) {
        this.currentIndex--;
      }
    },
    setVideo(index) {
      this.currentIndex = index;
    }
  }
};
</script>

<style scoped>
.company-videos-container {
  margin: 2rem 0;
}

/* Responsive Video Container */
.video-responsive {
  position: relative;
  padding-bottom: 56.25%; /* 16:9 Aspect Ratio */
  height: 0;
  overflow: hidden;
}

.video-responsive iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: 0;
}

/* Grid Layout */
.video-grid {
  display: flex;
  flex-wrap: wrap;
  margin: -15px;
}

.video-wrapper {
  padding: 15px;
}

/* Carousel Layout */
.carousel-container {
  position: relative;
  max-width: 800px;
  margin: 0 auto;
}

.carousel-nav {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  background: rgba(0, 0, 0, 0.5);
  color: white;
  border: none;
  padding: 1rem;
  cursor: pointer;
  font-size: 1.5rem;
  transition: background-color 0.3s;
  z-index: 2;
}

.carousel-nav:hover:not(:disabled) {
  background: rgba(0, 0, 0, 0.8);
}

.carousel-nav:disabled {
  background: rgba(0, 0, 0, 0.2);
  cursor: not-allowed;
}

.carousel-nav.prev {
  left: 0;
}

.carousel-nav.next {
  right: 0;
}

.carousel-indicators {
  display: flex;
  justify-content: center;
  margin-top: 1rem;
  gap: 0.5rem;
}

.indicator {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  border: none;
  background: #ccc;
  cursor: pointer;
  padding: 0;
}

.indicator.active {
  background: #343538;
}

/* Responsive Design */
@media (max-width: 768px) {
  .carousel-nav {
    padding: 0.5rem;
    font-size: 1rem;
  }
  
  .video-wrapper {
    width: 100%;
  }
}
</style>
